import { API_URI } from "../../constants/consts";
import { api } from "../../services/apis/configs/axiosConfigs";

import {
  type DiagramSimple,
  type DiagramFull,
  type GetDiagramsResponse,
  type CreateDiagramInput,
  type UpdateDiagramInput,
  type DiagramWithQuestionsFull,
} from "./types/types";

/**
 * Utilitário de API para gerenciar operações CRUD de Diagrams.
 */
export const diagramAPI = {
  /**
   * Busca todos os diagrams com paginação e filtro de busca.
   */
  getAll: async (
    search: string = "",
    page: number = 1,
    token: string,
    perPage: number = 10
  ): Promise<GetDiagramsResponse> => {
    const searchQuery = search ? `&search=${search}` : "";
    const url = `${API_URI}/admin/private/diagrams?page=${page}&perPage=${perPage}${searchQuery}`;

    return api
      .request({
        url,
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        const { data } = response.data;

        const pagination = data.pagination
          ? {
              currentPage: data.pagination.currentPage,
              totalPages: data.pagination.totalPages,
              itemsPerPage: data.pagination.itemsPerPage,
              totalItems: data.pagination.totalItems,
            }
          : {
              currentPage: 0,
              totalPages: 0,
              itemsPerPage: 0,
              totalItems: 0,
            };

        return {
          diagrams: data.diagrams || [],
          pagination,
        };
      })
      .catch((error) => {
        console.error("Error fetching diagrams:", error);
        throw new Error("Failed to fetch diagrams");
      });
  },

  /**
   * Busca um diagram específico pelo ID.
   */
  getById: async (id: string, token: string): Promise<DiagramFull> => {
    const url = `${API_URI}/admin/private/diagrams/${id}`;

    return api
      .request({
        url,
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        const { data } = response.data;
        if (!data) throw new Error("Diagram not found");
        return data as DiagramFull;
      })
      .catch((error) => {
        console.error("Error fetching diagram by ID:", error);
        throw new Error("Failed to fetch diagram");
      });
  },

  /**
   * Busca um diagram específico pelo ID.
   */
  getByIdFull: async (
    id: string,
    token: string
  ): Promise<DiagramWithQuestionsFull> => {
    const url = `${API_URI}/admin/private/diagrams/${id}/full`;

    return api
      .request({
        url,
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        const { data } = response.data;

        console.log("DiagramWithQuestionsFull", data);

        console.log("DiagramWithQuestionsFull", data);

        if (!data) throw new Error("Diagram not found");
        return data as DiagramWithQuestionsFull;
      })
      .catch((error) => {
        console.error("Error fetching diagram by ID:", error);
        throw new Error("Failed to fetch diagram");
      });
  },

  /**
   * Cria um novo diagram.
   */
  create: async (
    data: CreateDiagramInput,
    token: string
  ): Promise<DiagramFull> => {
    const url = `${API_URI}/admin/private/diagrams`;

    console.log("Creating diagram with data:", data);
    console.log("url", url);

    return api
      .request({
        url,
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        data,
      })
      .then((response) => response.data.data as DiagramFull)
      .catch((error) => {
        console.error("Error creating diagram:", error);
        throw new Error("Failed to create diagram");
      });
  },

  /**
   * Atualiza um diagram existente.
   */
  update: async (
    id: string,
    data: UpdateDiagramInput,
    token: string
  ): Promise<DiagramFull> => {
    const url = `${API_URI}/admin/private/diagrams/${id}`;

    return api
      .request({
        url,
        method: "PUT",
        headers: { Authorization: `Bearer ${token}` },
        data,
      })
      .then((response) => response.data.data as DiagramFull)
      .catch((error) => {
        console.error("Error updating diagram:", error);
        throw new Error("Failed to update diagram");
      });
  },

  /**
   * Exclui (soft delete) um diagram existente.
   */
  delete: async (id: string, token: string): Promise<any> => {
    const url = `${API_URI}/admin/private/diagrams/${id}`;

    return api
      .request({
        url,
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => response.data)
      .catch((error) => {
        console.error("Error deleting diagram:", error);
        throw new Error("Failed to delete diagram");
      });
  },
};
